/** @format */

import React, { Fragment } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { createBundle } from 'widget/Common';
import TreeHelp from 'utils/TreeHelp';
import { CacheSwitch, CacheRoute } from 'react-router-cache-route';
import RouterCache from 'utils/routerCache';
// 页面找不到组件
import NotFound from 'bundle-loader?lazy&name=NotFoundView!widget/NotFound/NotFoundView';
// 未获得任何授权
import WithoutPermission from 'bundle-loader?lazy&name=WithoutPermission!pages/WithoutPermission/WithoutPermissionView';
// 产品列表
import ProductList from 'bundle-loader?lazy&name=productListView!pages/ProductList/ProductListView';
// 子系统页面
import ProductDetail from 'bundle-loader?lazy&name=productDetailView!pages/ProductDetail/ProductDetailView';
// 新增用户列表
import NewUserList from 'bundle-loader?lazy&name=userListView!pages/UserMgmt/UserList/UserListView';
//租户概览
import TenantDetail from 'bundle-loader?lazy&name=tenantDetailView!pages/TenantMgmt/TenantDetail/TenantDetailView';
//关联用户
import UserRelate from 'bundle-loader?lazy&name=userRelateView!pages/RoleMgmt/UserRelate/UserRelateView';
//新增角色
import RoleAdd from 'bundle-loader?lazy&name=roleAddView!pages/RoleMgmt/RoleAdd/RoleAddView';
//新增用户
import UserAdd from 'bundle-loader?lazy&name=userAddView!pages/UserMgmt/UserAdd/UserAddView';
//角色管理
import RoleList from 'bundle-loader?lazy&name=roleListView!pages/RoleMgmt/RoleList/RoleListView';
//角色关联属性
import AssociateAttr from 'bundle-loader?lazy&name=AssociateAttrView!pages/RoleMgmt/AssociateAttr/AssociateAttrView';

//权限基础配置
import AuthBasicConfig from 'bundle-loader?lazy&name=AuthBasicConfig!pages/AuthMgr/AuthBasicConfig/AuthBasicConfigView';

// 组织属性
import OrgAttr from 'bundle-loader?lazy&name=OrgAttr!pages/bundle-org-mgmt/OrgAttr/OrgAttrView';
// 人事组织单元
import BusinessUnit from 'bundle-loader?lazy&name=BusinessUnit!pages/bundle-org-mgmt/BusinessUnit/BusinessUnitView';
// 销售组织单元
import BusinessCellUnit from 'bundle-loader?lazy&name=BusinessUnit!pages/bundle-org-mgmt/BusinessCellUnit/BusinessUnitView';
//组织列表
import OrgMgr from 'bundle-loader?lazy&name=OrgMgr!pages/bundle-org-mgmt/OrgMgr/OrgMgrView';
//组织详情
import OrgDetail from 'bundle-loader?lazy&name=OrgMgr!pages/bundle-org-mgmt/OrgDetail/OrgDetailView';
//全部岗位
import AllPost from 'bundle-loader?lazy&name=AllPost!pages/bundle-org-mgmt/AllPost/AllPostView';
//全部员工
import AllEmployee from 'bundle-loader?lazy&name=AllPost!pages/bundle-org-mgmt/AllEmployee/AllEmployeeView';
//员工绑定用户
import EmployeeUserList from 'bundle-loader?lazy&name=EmployeeUserList!pages/bundle-org-mgmt/EmployeeUserList/EmployeeUserListView';

// 应用资源
import ApplicationResources from 'bundle-loader?lazy&name=applicationResourcesView!pages/ResourceManage/ApplicationResources/ApplicationResourcesView';
// 登陆日志
import LogLogin from 'bundle-loader?lazy&name=LogLoginView!pages/LogManage/LogLogin/LogLoginView';

//已发消息
import SentMessage from 'bundle-loader?lazy&name=SentMessageView!pages/MessageManage/SentMessage/SentMessageView';
//我的消息
import MyMessage from 'bundle-loader?lazy&name=MyMessageView!pages/MessageManage/MyMessage/MyMessageView';
//消息事件
import MessageEvents from 'bundle-loader?lazy&name=MessageEventsView!pages/MessageManage/MessageEvents/MessageEventsView';
//消息详情配置
import MessageDetail from 'bundle-loader?lazy&name=MessageDetailView!pages/MessageManage/MessageDetail/MessageDetailView';
//手工推送消息
import ManuallySend from 'bundle-loader?lazy&name=ManuallySendView!pages/MessageManage/ManuallySend/ManuallySendView';
//手工推送消息详情
import ManuallyDetail from 'bundle-loader?lazy&name=ManuallyDetailView!pages/MessageManage/ManuallyDetail/ManuallyDetailView';
// 调度中心页面
import JobManage from 'bundle-loader?lazy&name=batchManageView!pages/DispatchCenter/JobManage/JobManageView';
import JobSampleManage from 'bundle-loader?lazy&name=batchManageView!pages/DispatchCenter/JobSampleManage/JobSampleManageView';
import TaskManage from 'bundle-loader?lazy&name=taskManageView!pages/DispatchCenter/TaskManage/TaskManageView';
import Report from 'bundle-loader?lazy&name=taskManageView!pages/DispatchCenter/Report/ReportView';
//应用资源管理
//资源注册
import ResourceRegister from 'bundle-loader?lazy&name=ResourceRegister!pages/bundle-appResource-mgmt/ResourceRegister/ResourceRegisterView';
//应用模板管理
import TemplateMgmt from 'bundle-loader?lazy&name=TemplateMgmt!pages/bundle-appResource-mgmt/TemplateMgmt/TemplateMgmtView';
//应用模板详情
import TemplateDetail from 'bundle-loader?lazy&name=TemplateDetail!pages/bundle-appResource-mgmt/TemplateDetail/TemplateDetailView';
//空间管理
import SpaceMgmt from 'bundle-loader?lazy&name=SpaceMgmt!pages/bundle-appResource-mgmt/SpaceMgmt/SpaceMgmtView';
//应用管理
import AppMgmt from 'bundle-loader?lazy&name=AppMgmt!pages/bundle-appResource-mgmt/AppMgmt/AppMgmtView';
//业务空间配置
import BusinessSpaceConfig from 'bundle-loader?lazy&nam/*  */e=BusinessSpaceConfig!pages/bundle-appResource-mgmt/BusinessSpaceConfig/BusinessSpaceConfigView';
//查看菜单
import BrowseMenu from 'bundle-loader?lazy&name=BrowseMenu!pages/bundle-appResource-mgmt/BrowseMenu/BrowseMenuView';
//资源初始化
import ConfigResource from 'bundle-loader?lazy&name=ConfigResource!pages/bundle-appResource-mgmt/ConfigResource/ConfigResourceView';

//系统管理
//首页公告栏配置
import HomeConfig from 'bundle-loader?lazy&name=HomeConfig!pages/SystemManage/HomeConfig/HomeConfigView';
//外部渠道管理
import ChannelAccountMgmt from 'bundle-loader?lazy&name=ChannelAccountMgmt!pages/SystemManage/ChannelAccountMgmt/ChannelAccountMgmtView';

import Device from 'bundle-loader?lazy&name=Pos!pages/Pos/Device/index';
import Version from 'bundle-loader?lazy&name=Pos!pages/Pos/Version/index';

// 云打印日志
import PrinterList from 'bundle-loader?lazy&name=PrinterList!pages/Printer/PrinterList/IndexView';
import PrinterLog from 'bundle-loader?lazy&name=PrinterLog!pages/Printer/PrinterLog/IndexView';
//---ROUTER_IMPORT---
// 上面这个标记不能去掉
const routerTree = [
  {
    title: '首页',
    path: '/',
    // 懒加载组件，用component，且组件使用createBundle包裹
    component: () => {
      const roleCode = localStorage.getItem('roleCode');
      if (roleCode === 'BOCMANAGER') {
        return createBundle(TenantDetail);
      } else {
        return createBundle(ProductList);
      }
    }
  },
  // 租户管理
  {
    title: '租户概览',
    path: '/tenantDetail',
    component: () => {
      return createBundle(TenantDetail);
    }
  },
  //权限管理
  {
    title: '用户管理',
    path: '/userList',
    component: () => {
      return createBundle(NewUserList);
    },
    children: [
      {
        title: '新增用户',
        path: '/userAdd',
        component: () => {
          return createBundle(UserAdd);
        }
      }
    ]
  },
  {
    title: '角色管理',
    path: '/roleList',
    component: () => {
      return createBundle(RoleList);
    },
    children: [
      {
        title: '关联用户',
        name_i1: 'Associated user',
        path: '/userRelate',
        component: () => {
          return createBundle(UserRelate);
        }
      },
      {
        title: '新增角色',
        path: '/roleAdd',
        component: () => {
          return createBundle(RoleAdd);
        }
      },
    ]
  },
  {
    title: '权限基础配置',
    path: '/AuthBasicConfig',
    component: () => {
      return createBundle(AuthBasicConfig);
    }
  },
  //组织管理
  {
    title: '职能组织列表',
    path: '/bundle-org-mgmt/OrgMgr',
    component: () => {
      return createBundle(OrgMgr);
    },
    children: [
      {
        title: '组织详情',
        name_i1: 'Organization details',
        path: '/bundle-org-mgmt/OrgDetail',
        component: () => {
          return createBundle(OrgDetail);
        }
      },
    ]
  },
  {
    title: '组织属性',
    path: '/bundle-org-mgmt/OrgAttr',
    component: () => {
      return createBundle(OrgAttr);
    }
  },
  {
    title: '人事业务单元列表',
    path: '/bundle-org-mgmt/BusinessUnit',
    component: () => {
      return createBundle(BusinessUnit);
    }
  },
  {
    title: '销售业务单元列表',
    path: '/bundle-org-mgmt/BusinessCellUnit',
    component: () => {
      return createBundle(BusinessCellUnit);
    }
  },
  {
    title: '全部岗位',
    path: '/bundle-org-mgmt/AllPost',
    component: () => {
      return createBundle(AllPost);
    }
  },
  {
    title: '全部员工',
    path: '/bundle-org-mgmt/AllEmployee',
    component: () => {
      return createBundle(AllEmployee);
    },
    children: [
      {
        title: '关联用户',
        name_i1: 'Associated user',
        path: '/bundle-org-mgmt/EmployeeUserList',
        component: () => {
          return createBundle(EmployeeUserList);
        }
      },
    ]
  },

  //菜单管理
  {
    title: '应用菜单',
    path: '/applicationResources',
    component: () => {
      return createBundle(ApplicationResources);
    }
  },
  //调度管理
  {
    title: '任务管理',
    path: '/taskManage',
    component: () => {
      return createBundle(TaskManage);
    }
  },
  {
    title: '任务运行报表',
    path: '/Report',
    component: () => {
      return createBundle(Report);
    }
  },
  {
    title: 'Job管理',
    path: '/jobManage',
    component: () => {
      return createBundle(JobManage);
    },
    children:[
      {
        title: 'Job实例管理',
        path: '/jobSampleManage',
        name_i1: 'Job instance management',
        component: () => {
          return createBundle(JobSampleManage);
        }
      },
    ]
  },
  //日志管理
  {
    title: '登录日志',
    path: '/logLogin',
    component: () => {
      return createBundle(LogLogin);
    }
  },
  //消息管理
  {
    title: '已发消息',
    path: '/sentMessage',
    component: () => {
      return createBundle(SentMessage);
    }
  },
  {
    title: '我的消息',
    path: '/myMessage',
    component: () => {
      return createBundle(MyMessage);
    }
  },
  {
    title: '消息事件',
    path: '/messageEvents',
    component: () => {
      return createBundle(MessageEvents);
    },
    children: [
      {
        title: '消息详情配置',
        path: '/messageDetail',
        name_i1: 'Message details configuration',
        component: () => {
          return createBundle(MessageDetail);
        }
      }
    ]
  },
  {
    title: '手工推送消息',
    path: '/manuallySend',
    component: () => {
      return createBundle(ManuallySend);
    },
    children: [
      {
        title: '手工推送消息详情',
        path: '/manuallyDetail',
        name_i1: 'Manual push message details',
        component: () => {
          return createBundle(ManuallyDetail);
        }
      }
    ]
  },
  //系统管理
  {
    title: '首页公告栏配置',
    path: '/homeConfig',
    component: () => {
      return createBundle(HomeConfig);
    }
  },
  {
    title: '外部渠道管理',
    path: '/ChannelAccountMgmt',
    component: () => {
      return createBundle(ChannelAccountMgmt);
    }
  },
  //应用资源
  {
    title: '空间管理',
    path: '/bundle-appResource-mgmt/SpaceMgmt',
    component: () => {
      return createBundle(SpaceMgmt);
    },
    children: [
      {
        title: '应用管理',
        path: '/bundle-appResource-mgmt/AppMgmt',
        name_i1: 'Application management',
        component: () => {
          return createBundle(AppMgmt);
        }
      },
      {
        title: '业务空间配置',
        path: '/bundle-appResource-mgmt/BusinessSpaceConfig',
        name_i1: 'Space configuration',
        component: () => {
          return createBundle(BusinessSpaceConfig);
        }
      },
      {
        title: '查看菜单',
        path: '/bundle-appResource-mgmt/BrowseMenu',
        name_i1: 'Check menu',
        component: () => {
          return createBundle(BrowseMenu);
        }
      },
      {
        title: '配置资源',
        path: '/bundle-appResource-mgmt/ConfigResource',
        name_i1: 'Configure resources',
        component: () => {
          return createBundle(ConfigResource);
        }
      }
    ]
  },
  {
    title: '资源注册',
    path: '/bundle-appResource-mgmt/ResourceRegister',
    component: () => {
      return createBundle(ResourceRegister);
    }
  },
  {
    title: '应用模板管理',
    path: '/bundle-appResource-mgmt/TemplateMgmt',
    component: () => {
      return createBundle(TemplateMgmt);
    },
    children: [
      {
        title: '应用模板详情',
        path: '/bundle-appResource-mgmt/TemplateDetail',
        name_i1: 'Application template details',
        component: () => {
          return createBundle(TemplateDetail);
        }
      }
    ]
  },
  //应用管理员菜单
  {
    title: '应用列表',
    path: '/productList',
    menuPath: '',
    component: () => {
      return createBundle(ProductList);
    }
  },
  {
    title: '首页',
    path: '/productDetail',
    component: () => {
      return createBundle(ProductDetail);
    }
  },
  //无权限
  {
    title: '无权限',
    path: '/withoutPermission',
    component: () => {
      return createBundle(WithoutPermission);
    }
  },
  //Pos管理
  {
    title: '设备管理',
    path: '/device',
    component: () => createBundle(Device),
  },
  {
    title: '版本管理',
    path: '/version',
    component: () => createBundle(Version),
  },
  {
    title: '云打印机管理',
    path: '/printer/printerList',
    menuPath: '',
    component: () => {
      return createBundle(PrinterList);
    },
    children: [
      {
        title: '查看日志',
        path: '/printer/printerLog',
        component: () => {
          return createBundle(PrinterLog);
        }
      }
    ]
  },
  //---ROUTER_APPEND---
  // 上面这个标记不能去掉
];
// export const routerList = TreeHelp.treeToList(routerTree, 'path');
export const routerList = routerTree;



// WEBPACK FOOTER //
// ./src/router/index.js